export default "__VITE_ASSET__CjLO7lFT__ 1250w";